import { appUrls } from '../config';

/**
 * Calls server logout API.
 *
 * Returs promise which is resolved after successful logout.
 * @export
 * @returns {Promise}
 */
export function logout() {
  return fetch(appUrls.logout, { credentials: 'include' });
}

/**
 * Logs in user with given username & password.
 *
 * Returs promise which is resolved after successful login.
 * @export
 * @param {String} username
 * @param {String} password
 * @returns {Promise}
 */
export function login(username, password) {
  const data = new FormData();

  data.append('org_code', username);
  data.append('p', password);

  const params = {
    method: 'post',
    body: data,
    credentials: 'include'
  };
  return fetch(appUrls.login, params).then(response => response.json());
}



// WEBPACK FOOTER //
// ./src/services/loginService.js